import { fetch } from "./lib/fetch";

type AppConfig = {
  BOAT_SERVICE_URL: string;
  PAYMENT_SERVICE_URL: string;
  AUTH_SERVICE_URL: string;
  WEBSITE_URL: string;
  SEARCH_URL: string;
};

let config: AppConfig;

export const loadConfig = async () => {
  const res: any = await fetch("/api/config/applications");
  console.log("Config response: ", res);
  config = res;
};

export const getConfig = (): AppConfig => {
  if (!config) throw new Error("Config not loaded yet");
  return config;
};
